import { groq } from "next-sanity";
import { ButtonFields } from "../partials/shared";

export const newsQuery = groq`*[
  _type == "newsPages"
  && publishedAt < coalesce($lastPublishedAt, now())
  && newsType->slug.current == coalesce($newsType, newsType->slug.current)]
  | order(publishedAt desc) [0...12]  {
    _type,
    title,
    description,
    publishedAt,
    duration,
    image{
      ...,
      "lqip": asset->metadata.lqip
    },
    "slug": slug.current,
    newsType->{
      title,
      "slug":slug.current
    },
    _id,
    link[0]{
      ${ButtonFields}
    }
}`;
